export const VEHICLE_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS: Record<
  string,
  string
> = {
  'car/sedan':
    'A four-door passenger car with a distinct hood, cabin, and trunk.',
  'car/hatchback':
    'A compact two-box passenger car with a roof-hinged rear liftgate.',
  'car/coupe': 'A fixed-roof passenger car with two doors and a sloping cabin.',
  'car/convertible':
    'A passenger car with a retractable or removable roof and an open cabin.',
  'car/wagon':
    'A passenger car with an extended roof and a full-height rear cargo area.',
  'car/suv': 'A tall enclosed utility vehicle with raised ground clearance.',
  'car/crossover':
    'A unified car-based utility body with moderately raised ride height.',
  'car/pickup-truck':
    'A vehicle with an enclosed front cabin and a separate open rear cargo bed.',
  'car/van':
    'A tall enclosed vehicle with a long roof and box-like cargo body.',
  'car/minivan':
    'A tall passenger vehicle with a spacious cabin and a sliding side door.',
  'car/sports-car':
    'A low, wide performance car with a compact passenger cabin.',
  'car/off-road':
    'A high-clearance vehicle with short overhangs and pronounced wheel arches.',

  'wheel/five-spoke':
    'A wheel face organized around five primary spokes and five open windows.',
  'wheel/split-five-spoke':
    'A wheel with five paired spoke groups that form ten ends at the rim.',
  'wheel/multi-spoke':
    'A wheel with many slender radial spokes and evenly repeated open windows.',
  'wheel/mesh':
    'A wheel face built from crossing spokes that form a dense lattice.',
  'wheel/turbine':
    'A directional wheel whose swept spokes create a continuous turbine pattern.',
  'wheel/aero-disc':
    'A mostly closed aerodynamic wheel face with only small cooling openings.',
  'wheel/steel':
    'A pressed steel wheel with a solid face and repeated ventilation holes.',
  'wheel/wire-spoke':
    'A wheel whose hub and rim are joined by many thin visibly laced wires.',
  'wheel/deep-dish':
    'A wheel with a recessed center and a wide outer lip projecting forward.',
  'wheel/concave':
    'A wheel with an inward-set hub and spokes that rise outward toward the rim.',
  'wheel/beadlock':
    'An off-road wheel with a bolted retaining ring around its reinforced rim.',
  'wheel/multi-piece':
    'A wheel assembled from separate center and rim sections with visible perimeter hardware.',

  'tire/passenger-touring':
    'A passenger-car tire with moderate sidewall height and a fine multi-rib road tread.',
  'tire/performance-road':
    'A low-profile road tire with broad shoulder blocks and an asymmetric tread.',
  'tire/winter':
    'A winter road tire with dense siping and open grooves that clear packed snow.',
  'tire/studded-winter':
    'A winter tire with dense siping and visible metal studs set into the tread blocks.',
  'tire/all-terrain':
    'A mixed-surface tire with interlocking tread blocks and reinforced open shoulders.',
  'tire/mud-terrain':
    'An off-road tire with widely separated tread lugs and aggressive sidewall blocks.',
  'tire/highway-terrain':
    'A highway-focused utility tire with continuous ribs and closed stable shoulders.',
  'tire/commercial-truck':
    'A heavy-duty truck tire with a tall reinforced sidewall and deep working tread.',
  'tire/trailer':
    'A load-bearing trailer tire with straight tracking ribs and a stiff sidewall.',
  'tire/temporary-spare':
    'A compact temporary spare tire with a narrow tread face and tall light sidewall.',
  'tire/track-slick':
    'A circuit tire with a wide smooth tread face and a low rigid sidewall.',
  'tire/drag-slick':
    'A drag-racing tire with an extra-wide smooth tread and a tall flexible sidewall.',
};
